'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  var ENV_DEV = window.ENV_DEV;
  app.constant('global', {});
};

; /**
   * 全局变量
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/global.js
// module id = 36
// module chunks = 0